(ns dashboard.views.settings.notifications
  (:require
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen]]
   [dashboard.components.button :refer [button]]))

(defn content []
  [:div.divide-y.divide-gray-200
   [:div.py-6.px-4.sm:p-6.lg:pb-8]
   [:div.divide-y.divide-gray-200
    [:div.py-4.px-4.flex.justify-end.sm:px-6
     [button
      {:type "submit"}
      (tr :action/save)]]]])
